import React, { useContext } from 'react';
import Loader from '../../Loader';
import ThemeContext from '../../helpers/ThemeContext';
import Preview from './Preview';
import Footer from './Footer';
import styles from './index.scss';

const Selection = () => {
  const { currentTheme } = useContext(ThemeContext);

  return (
    <div className={styles.container}>
      {currentTheme ? (
        <div className={`${styles.imagesWrapper}`}>
          <Preview />
          <Footer />
        </div>
      ) : (
        <div className={`${styles.loaderWrap}`}>
          <Loader />
        </div>
      )}
    </div>
  );
};

export default Selection;
